import { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { OutcomeType } from 'utils/adl-services';
import useGetParentGroup from 'utils/hooks/useGetParentGroup';

import { makeSelectLogicPaths } from 'containers/QuestionnairePage/selectors';
import { makeSelectSurveyId } from 'containers/Survey/selectors';
import useNavigation from 'containers/QuestionnairePage/GenericQuestion/QuestionFooter/hooks/useNavigation';
import { addStatement } from 'containers/QuestionnaireLogic/actions';

import { isTextQuestionType } from 'components/LogicMatcher/utils';
import editMessages from 'components/EditAdlTooltip/messages';

import { REASON_QUESTIONNAIRE_QUOTA_FULL } from 'components/LogicOutcome/constants';
import { hasNodeLogicPath } from '../utils';
import { SHUFFLE_NONE } from '../../DropdownShuffle/constants';
import messages from '../messages';

function useStatePropsAndActions(nodeRefId, nodeType) {
  const dispatch = useDispatch();
  const parentGroup = useGetParentGroup(nodeRefId);
  const inShuffledGroup =
    Boolean(parentGroup) && parentGroup.shuffle !== SHUFFLE_NONE;
  const logicPaths = useSelector(makeSelectLogicPaths);
  const surveyId = useSelector(makeSelectSurveyId);
  const { goToLogic } = useNavigation({ surveyId });

  const isSet = useMemo(() => {
    // exlude quota full logic paths as they are not supported in the advanced logic tab
    const navigationLogicPaths = (logicPaths || []).filter(
      (path = []) => path[2] !== REASON_QUESTIONNAIRE_QUOTA_FULL,
    );
    return hasNodeLogicPath(navigationLogicPaths, nodeRefId);
  }, [logicPaths, nodeRefId]);

  const onNavigate = useCallback(() => {
    goToLogic();

    if (!isSet) {
      dispatch(
        addStatement({
          nodeRefId,
          isText: isTextQuestionType(nodeType),
          outcomeType: OutcomeType.Success,
        }),
      );
    }
  }, [goToLogic, nodeRefId, nodeType, isSet, dispatch]);

  return {
    inShuffledGroup,
    isSet,
    onNavigate,
    tooltipMessage: isSet ? editMessages.title : messages.addAdvancedLogic,
  };
}

export default useStatePropsAndActions;
